import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/site";

export default function NavBar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 48);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || open;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        solid
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <div className="px-4 md:px-8 h-16 flex items-center justify-between">
        <a
          href="#top"
          className={`flex items-center gap-2 cursor-pointer ${
            solid ? "text-foreground-950" : "text-background-50"
          }`}
        >
          <span className="w-8 h-8 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
            <i className="ri-film-line text-lg"></i>
          </span>
          <span className="font-heading font-bold tracking-wide text-base md:text-lg whitespace-nowrap">
            韩国伦理电影
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-1">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`px-3 py-2 text-sm rounded-md cursor-pointer transition-colors whitespace-nowrap ${
                solid
                  ? "text-foreground-700 hover:text-primary-600 hover:bg-background-100"
                  : "text-background-100 hover:text-background-50 hover:bg-background-50/10"
              }`}
            >
              {link.label}
            </a>
          ))}
          <a
            href="#films"
            className="ml-2 px-4 py-2 text-sm rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看片单
          </a>
        </nav>

        <button
          type="button"
          aria-label="打开导航菜单"
          onClick={() => setOpen((value) => !value)}
          className={`lg:hidden w-9 h-9 flex items-center justify-center rounded-md cursor-pointer ${
            solid
              ? "text-foreground-950 hover:bg-background-100"
              : "text-background-50 hover:bg-background-50/10"
          }`}
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-background-50 border-t border-background-200 px-4 py-3">
          <nav className="flex flex-col">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="py-2.5 text-sm text-foreground-700 hover:text-primary-600 cursor-pointer whitespace-nowrap"
              >
                {link.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}